import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import { Input as FluentInput, mergeClasses, useId } from "@fluentui/react-components";
import { InfoLabel } from "./infoLabel";
import { HandleKeyDown, HandleOnBlur, useInputStyles } from "./utils";
import { ToolContext } from "../hoc/fluentToolWrapper";
export const TextInput = (props) => {
    TextInput.displayName = "TextInput";
    const classes = useInputStyles();
    const [value, setValue] = useState(props.value);
    const lastCommittedValue = useRef(props.value);
    const { size } = useContext(ToolContext);
    useEffect(() => {
        if (props.value !== lastCommittedValue.current) {
            setValue(props.value); // Update local state when props.value changes
            lastCommittedValue.current = props.value;
        }
    }, [props.value]);
    const validateValue = (val) => {
        if (!props.validator) {
            return true;
        }
        return props.validator(val);
    };
    const tryCommitValue = (currVal) => {
        // Only commit if valid and different from last committed value
        if (validateValue(currVal) && currVal !== lastCommittedValue.current) {
            lastCommittedValue.current = currVal;
            props.onChange(currVal);
        }
    };
    const handleChange = (event, data) => {
        event.stopPropagation();
        setValue(data.value);
        if (!props.validateOnlyOnBlur) {
            tryCommitValue(data.value);
        }
    };
    const handleKeyUp = (event) => {
        event.stopPropagation();
        if (!props.validateOnlyOnBlur) {
            tryCommitValue(event.currentTarget.value);
        }
    };
    const handleKeyDown = (event) => {
        HandleKeyDown(event);
        // When validateOnlyOnBlur is set, also commit on Enter for better UX
        if (event.key === "Enter" && props.validateOnlyOnBlur) {
            tryCommitValue(event.currentTarget.value);
        }
    };
    const handleBlur = (event) => {
        HandleOnBlur(event);
        if (props.validateOnlyOnBlur) {
            tryCommitValue(event.currentTarget.value);
        }
    };
    const mergedClassName = mergeClasses(classes.inputFill, !validateValue(value) ? classes.invalid : "");
    const id = useId("input-button");
    return (_jsxs("div", { className: mergeClasses(classes.container, props.className), children: [props.infoLabel && _jsx(InfoLabel, { ...props.infoLabel, htmlFor: id }), _jsx(FluentInput, { ...props, input: { className: classes.inputSlot }, id: id, size: size, value: value, onChange: handleChange, onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, onBlur: handleBlur, className: mergedClassName })] }));
};
//# sourceMappingURL=textInput.js.map